export const handleChangePage = (
  event: unknown,
  newPage: number,
  setPage: any
) => {
  setPage(newPage);
  localStorage.setItem("sitesTablePage", newPage.toString());
};
